/* tslint:disable */
/* eslint-disable */
/**
 * Solaris User API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetHealth200Response } from '../model';
// @ts-ignore
import { VerifyToken200Response } from '../model';
// @ts-ignore
import { VerifyToken401Response } from '../model';
/**
 * OperationalApi - axios parameter creator
 * @export
 */
export const OperationalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the health status of the user gateway
         * @summary Health check endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealth: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verifies the JWT token and returns token information without performing any updates
         * @summary Verify JWT token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyToken: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/auth/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BrandGatewayAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OperationalApi - functional programming interface
 * @export
 */
export const OperationalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OperationalApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the health status of the user gateway
         * @summary Health check endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHealth(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetHealth200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHealth(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Verifies the JWT token and returns token information without performing any updates
         * @summary Verify JWT token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyToken(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyToken200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyToken(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OperationalApi - factory interface
 * @export
 */
export const OperationalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OperationalApiFp(configuration)
    return {
        /**
         * Returns the health status of the user gateway
         * @summary Health check endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealth(options?: AxiosRequestConfig): AxiosPromise<GetHealth200Response> {
            return localVarFp.getHealth(options).then((request) => request(axios, basePath));
        },
        /**
         * Verifies the JWT token and returns token information without performing any updates
         * @summary Verify JWT token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyToken(options?: AxiosRequestConfig): AxiosPromise<VerifyToken200Response> {
            return localVarFp.verifyToken(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OperationalApi - object-oriented interface
 * @export
 * @class OperationalApi
 * @extends {BaseAPI}
 */
export class OperationalApi extends BaseAPI {
    /**
     * Returns the health status of the user gateway
     * @summary Health check endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationalApi
     */
    public getHealth(options?: AxiosRequestConfig) {
        return OperationalApiFp(this.configuration).getHealth(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verifies the JWT token and returns token information without performing any updates
     * @summary Verify JWT token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationalApi
     */
    public verifyToken(options?: AxiosRequestConfig) {
        return OperationalApiFp(this.configuration).verifyToken(options).then((request) => request(this.axios, this.basePath));
    }
}
